const IMG = "https://static.prod-images.emergentagent.com/jobs/34f410c9-c8c3-4ee7-89cd-86df06bf8d8b/images/bcf1056cf3c7d34a52a13685db40bcd055902038441a0175b71bdea0f08b46e5.jpeg";

export default function AmbientBackground() {
  return (
    <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden" aria-hidden="true">
      {/* warm base */}
      <div className="absolute inset-0 bg-[#0a0705]" />
      {/* skyline image */}
      <img src={IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-[0.22]" />
      {/* warm glows */}
      <div className="absolute -top-[15%] right-[-10%] h-[65vh] w-[65vh] rounded-full bg-[#FF5A1F]/25 blur-[130px]" />
      <div className="absolute top-[35%] left-[-10%] h-[55vh] w-[55vh] rounded-full bg-[#FF7A2F]/12 blur-[140px]" />
      <div className="absolute bottom-[-10%] right-[10%] h-[50vh] w-[50vh] rounded-full bg-[#FF3B00]/10 blur-[140px]" />
      {/* readability vignette (warm) */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0705]/60 via-[#0a0705]/82 to-[#0a0705]/94" />
      <div className="absolute inset-0 bg-[radial-gradient(120%_80%_at_50%_0%,transparent_30%,rgba(10,7,5,0.6)_100%)]" />
    </div>
  );
}
